module.exports = __webpack_public_path__ + "img/truck-pin.81baf732.png";